import { Component, OnDestroy, OnInit } from '@angular/core';

import { BaseCtrlValueAccessorFormComponent } from '@sim/form/components/base-ctrl-value-accessor-form.component';

import { CDG } from '@atmi/core/models';

@Component({
  selector: 'app-cdg-form',
  styleUrls: ['./cdg-form.component.scss'],
  templateUrl: './cdg-form.component.html',
})
export class CdgFormComponent extends BaseCtrlValueAccessorFormComponent<CDG> implements OnDestroy, OnInit {

  constructor() {
    super();
  }

  ngOnInit() {
    super.ngOnInit();
  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }
}

